<template>
    <b-container class="p-0 h-100 ghostParameter">
    </b-container>
</template>

<script lang="ts">

    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "../locales/ParametersItems.json";
    import Parameter from '../Parameter';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales }
    })
	export default class GhostItem extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop()
        public Parameter!: Parameter;

        mounted(){
            this.$emit('child-event', 'mounted');
        }

        updated(){
            this.$emit('child-event', 'updated');
        }
    }

</script>

<style scoped>
    .ghostParameter{
        min-height: 30px;
        border: 2px dashed #222 !important;
        background-color: gray;
        opacity: 0.2;
    }

    .selectedGhostParameter{
        background-color: green;
    }
</style>